module.exports = __webpack_public_path__ + "static/media/S2N12-1.a93ce11a.svg";